export class AccountUI {
  constructor(root, { auth, onSession }) {
    this.root = root;
    this.auth = auth;
    this.onSession = onSession;
    this.opened = false;
    this.busy = false;
    this.error = '';
    this.notice = '';
    this.tab = 'login';
    this.root.innerHTML = '<div class="account-backdrop" hidden></div>';
    this.backdrop = this.root.firstElementChild;
    this.auth.onChange((session) => {
      this.busy = false;
      this.error = '';
      this.render();
      this.onSession(session);
    });
  }

  open() {
    this.opened = true;
    this.render();
  }

  close() {
    if (this.busy) return;
    this.opened = false;
    this.render();
  }

  render() {
    this.backdrop.hidden = !this.opened;
    if (!this.opened) return;
    if (!this.auth.configured) {
      this.backdrop.innerHTML = this.shell('ACCOUNT LINK UNAVAILABLE', '<p>Set the shared Supabase environment variables in this build to use the same identity as Survivor.</p>', '<button data-account-close> CLOSE </button>');
      this.bindCommon();
      return;
    }
    if (this.auth.session) {
      this.backdrop.innerHTML = this.shell('SHARED IDENTITY', `<p class="account-status">SIGNED IN AS <strong>${this.escape(this.auth.username)}</strong></p><p>This identity is shared with Survivor. Total Defence keeps its own cloud save under the same account.</p>`, `<button class="account-danger" data-account-logout ${this.busy ? 'disabled' : ''}> SIGN OUT </button><button data-account-close> CLOSE </button>`);
      this.bindCommon();
      this.backdrop.querySelector('[data-account-logout]')?.addEventListener('click', () => this.logout());
      return;
    }
    const tabs = `<div class="account-tabs"><button class="${this.tab === 'login' ? 'active' : ''}" data-account-tab="login">LOG IN</button><button class="${this.tab === 'signup' ? 'active' : ''}" data-account-tab="signup">CREATE ACCOUNT</button></div>`;
    const form = this.tab === 'login' ? `<input name="identifier" autocomplete="username" placeholder="Username or email" required><input name="password" type="password" autocomplete="current-password" placeholder="Password" required><button class="account-primary" type="submit" ${this.busy ? 'disabled' : ''}>LOG IN</button>` : `<input name="username" autocomplete="username" placeholder="Username (3–20 characters)" maxlength="20" required><input name="email" type="email" autocomplete="email" placeholder="Email" required><input name="password" type="password" autocomplete="new-password" placeholder="Password" required><input name="confirm" type="password" autocomplete="new-password" placeholder="Confirm password" required><button class="account-primary" type="submit" ${this.busy ? 'disabled' : ''}>CREATE ACCOUNT</button>`;
    this.backdrop.innerHTML = this.shell('LINK YOUR WATCH', '<p>Use the same Survivor credentials to share one Melodia identity across both games. Your current guest watch is backed up locally while the cloud save loads.</p>', `${tabs}<form data-account-form>${form}</form>${this.notice ? `<p class="account-notice">${this.escape(this.notice)}</p>` : ''}${this.error ? `<p class="account-error">${this.escape(this.error)}</p>` : ''}<button data-account-close> CANCEL </button>`);
    this.bindCommon();
    this.backdrop.querySelectorAll('[data-account-tab]').forEach((button) => button.addEventListener('click', () => { this.tab = button.dataset.accountTab; this.error = ''; this.notice = ''; this.render(); }));
    this.backdrop.querySelector('[data-account-form]')?.addEventListener('submit', (event) => { event.preventDefault(); this.submit(new FormData(event.currentTarget)); });
  }

  shell(title, copy, actions) {
    return `<section class="account-dialog"><span class="eyebrow">TOTAL DEFENCE / ACCOUNT</span><h2>${title}</h2>${copy}<div class="account-actions">${actions}</div></section>`;
  }

  bindCommon() {
    this.backdrop.querySelector('[data-account-close]')?.addEventListener('click', () => this.close());
    this.backdrop.addEventListener('click', (event) => { if (event.target === this.backdrop) this.close(); }, { once: true });
  }

  async submit(form) {
    this.busy = true;
    this.error = '';
    this.notice = '';
    this.render();
    const values = Object.fromEntries(form.entries());
    const result = this.tab === 'login'
      ? await this.auth.signIn(values.identifier, values.password)
      : values.password !== values.confirm
        ? { ok: false, error: 'Passwords do not match.' }
        : await this.auth.signUp({ username: values.username, email: values.email, password: values.password });
    this.busy = false;
    if (!result.ok) {
      this.error = result.error;
      this.render();
      return;
    }
    if (!result.confirmed) {
      this.tab = 'login';
      this.notice = 'Check your email to confirm the account, then log in here.';
      this.render();
      return;
    }
    this.opened = false;
    this.render();
  }

  async logout() {
    this.busy = true;
    this.render();
    await this.auth.signOut();
  }

  escape(value) {
    return String(value).replace(/[&<>"']/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character]));
  }
}
